var _defs, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDodge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.3 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #000;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st1, .st4, .st6, .st7, .st9, .st11, .st13, .st16, .st17, .st18, .st20, .st21 {\n        fill: none;\n      }\n\n      .st1, .st2, .st3, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22 {\n        stroke: gray;\n      }\n\n      .st1, .st3, .st7, .st11, .st13, .st16, .st17, .st18 {\n        stroke-width: .8px;\n      }\n\n      .st2, .st3, .st10 {\n        fill: #44b649;\n      }\n\n      .st23, .st5, .st8, .st19 {\n        fill: #fff;\n      }\n\n      .st4, .st6 {\n        stroke: #fff;\n      }\n\n      .st5 {\n        stroke: #7f7f7f;\n      }\n\n      .st6, .st9, .st10, .st12, .st19 {\n        stroke-width: .5px;\n      }\n\n      .st7 {\n        stroke-dasharray: 7.5 1.9;\n      }\n\n      .st11 {\n        stroke-dasharray: 6.8 1.7;\n      }\n\n      .st13 {\n        stroke-dasharray: 9.7 2.4;\n      }\n\n      .st14 {\n        fill: #ccc;\n        stroke-dasharray: 3 2;\n      }\n\n      .st24 {\n        display: none;\n      }\n\n      .st16 {\n        stroke-dasharray: 8.4 2.1;\n      }\n\n      .st17 {\n        stroke-dasharray: 7.6 1.9;\n      }\n\n      .st18 {\n        stroke-dasharray: 7.5 1.9;\n      }\n\n      .st25 {\n        fill: gray;\n      }\n\n      .st21 {\n        stroke-dasharray: 2.9 2.9;\n      }\n\n      .st22 {\n        fill: #2c5583;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M15.5,30.5l-2.2-7.1-.2-4.4-2.4-.4.8-4c.6-1.6,1-3.9,2.7-4.7l1.8-.8v-1.1c.1,0-.2-.2-.2-.2-3.2-2.5-2.3-6,1.7-6.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.3,30.6l-2.2-7.1-.2-4.4-2.4-.4.8-4c.6-1.6,1-3.9,2.7-4.7l1.8-.8v-1.1c.1,0-.2-.2-.2-.2-3.2-2.5-2.3-6,1.7-6.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15.3,30.3l-2.2-7.1-.2-4.4-2.4-.4.8-4c.6-1.6,1-3.9,2.7-4.7l1.8-.8v-1.1c.1,0-.2-.2-.2-.2-3.2-2.5-2.3-6,1.7-6.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M21.9,30.3l-2.2-7.1-.2-4.4-2.4-.4.8-4c.6-1.6,1-3.9,2.7-4.7l1.8-.8v-1.1c.1,0-.2-.2-.2-.2-3.2-2.5-2.3-6,1.7-6.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 9.8,
    y1: 7.6,
    x2: 26.4,
    y2: 7.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 8.5,
    y1: 11.5,
    x2: 23.3,
    y2: 12.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 8.2,
    y1: 16.4,
    x2: 23.3,
    y2: 17.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 8,
    y1: 20.5,
    x2: 24.4,
    y2: 22.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 13.7,
    y1: 26,
    x2: 25.8,
    y2: 27.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 9.8,
    y: 0.5,
    width: 29.9,
    height: 29.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "DEF",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M24.7,30.4s7.8-2,9.5-4c3.6-4.2,5.4-21.8,5.4-21.8,0,0-5.2-2.8-15-4.1-9.8,1.3-15,4.1-15,4.1,0,0,1.8,17.5,5.4,21.8,1.7,2,9.5,4,9.5,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.2,28.3s6.3-2,7.7-3.7c3-3.6,4.6-18.2,4.6-18.2,0,0-4-2-12.2-3.1v25Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "MDEF",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M24.7,30.4s7.8-2,9.5-4c3.6-4.2,5.4-21.8,5.4-21.8,0,0-5.2-2.8-15-4.1-9.8,1.3-15,4.1-15,4.1,0,0,1.8,17.5,5.4,21.8,1.7,2,9.5,4,9.5,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.2,28.3s6.3-2,7.7-3.7c3-3.6,4.6-18.2,4.6-18.2,0,0-4-2-12.2-3.1v25Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "DB",
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M24.7,30.4s7.8-2,9.5-4c3.6-4.2,5.4-21.7,5.4-21.7,0,0-5.1-2.8-14.9-4.1-9.8,1.3-14.9,4.1-14.9,4.1,0,0,1.8,17.5,5.4,21.7,1.7,2,9.5,4,9.5,4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.1,8.7c.3-2.4.5-4,.5-4,0,0-1.3-.7-3.7-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M33.9,2.5c-2.4-.7-5.5-1.4-9.2-1.9-4.3.6-7.8,1.4-10.2,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.5,3.2c-2.4.8-3.7,1.5-3.7,1.5,0,0,.2,1.6.5,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.5,10.5c.9,5.5,2.4,13.3,4.6,15.9,1.7,2,9.5,4,9.5,4,0,0,7.8-2,9.5-4,2.4-2.8,4-11.3,4.8-16.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M24.4,23.4s4.2-1.1,5.1-2.1c1.9-2.3,2.9-11.6,2.9-11.6,0,0-2.7-1.5-7.9-2.2-5.2.7-7.9,2.2-7.9,2.2,0,0,1,9.3,2.9,11.6.9,1.1,5.1,2.1,5.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.6,22.1s3.3-.8,4.1-1.7c1.6-1.9,2.4-9.7,2.4-9.7,0,0-2.1-1.1-6.5-1.6,0,0,0,13,0,13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.9,11.6c.3-2.3.5-4,.5-4,0,0-1.3-.7-3.7-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M29.3,5.5c-1.4-.3-3-.6-4.8-.9-2.4.3-4.4.7-6,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.4,6.2c-2.5.8-3.7,1.4-3.7,1.4,0,0,.2,1.7.5,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M14.5,13.5c.7,3.8,1.7,8.3,3.1,10,1.2,1.4,6.9,2.9,6.9,2.9,0,0,5.7-1.5,6.9-2.9,1.5-1.8,2.6-7,3.3-10.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,10.1c.3-2.3.5-4,.5-4,0,0-1.3-.7-3.7-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32,4.2c-2-.6-4.5-1.1-7.5-1.5-3.5.5-6.3,1.1-8.3,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.4,4.7c-2.5.8-3.7,1.5-3.7,1.5,0,0,.2,1.6.5,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M12.5,12c.8,4.7,2.1,10.8,3.9,12.9,1.5,1.7,8.2,3.5,8.2,3.5,0,0,6.7-1.7,8.2-3.5,1.9-2.3,3.3-9.1,4-13.8"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ACC",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M12.1,10.9c0-4.4,3.6-8,8-8v2.8c-2.9,0-5.2,2.3-5.2,5.2,0,0-2.8,0-2.8,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 23.6,
    y: 0.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M29.3,2.9c4.4,0,8,3.6,8,8h-2.8c0-2.9-2.3-5.2-5.2-5.2v-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 33.7,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M37.3,20c0,4.4-3.6,8-8,8v-2.8c2.9,0,5.2-2.3,5.2-5.2h2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 23.6,
    y: 24.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M20.2,28.1c-4.4,0-8-3.6-8-8h2.8c0,2.9,2.3,5.2,5.2,5.2v2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 9.8,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M26.2,15.8c0,.8-.6,1.4-1.4,1.4s-1.4-.6-1.4-1.4.6-1.4,1.4-1.4,1.4.6,1.4,1.4Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "MACC",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M12.1,10.9c0-4.4,3.6-8,8-8v2.8c-2.9,0-5.2,2.3-5.2,5.2,0,0-2.8,0-2.8,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 23.6,
    y: 0.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M29.3,2.9c4.4,0,8,3.6,8,8h-2.8c0-2.9-2.3-5.2-5.2-5.2v-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 33.7,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M37.3,20c0,4.4-3.6,8-8,8v-2.8c2.9,0,5.2-2.3,5.2-5.2h2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 23.6,
    y: 24.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M20.2,28.1c-4.4,0-8-3.6-8-8h2.8c0,2.9,2.3,5.2,5.2,5.2v2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 9.8,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M26.2,15.8c0,.8-.6,1.4-1.4,1.4s-1.4-.6-1.4-1.4.6-1.4,1.4-1.4,1.4.6,1.4,1.4Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M12.3,6.2c6-.6,17.9.4,18,9.3l-3.4.3,5.6,4.2,4.7-5.2-3.2.3c0-12.2-14.8-13.7-23-12.9l1.3,4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    cx: 32.3,
    cy: 25.9,
    rx: 2.1,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M39.8,25.9c0,1.7-3.4,3.1-7.5,3.1s-7.5-1.4-7.5-3.1,3.4-3.1,7.5-3.1,7.5,1.4,7.5,3.1Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "RNG",
    className: "st24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 9.8,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 14.8,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "39.6 13.6 29.7 2.8 29.7 4 19.8 4 19.8 23.2 29.7 23.2 29.7 24.4 39.6 13.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "9.8 27.7 9.8 29.6 19.7 29.6 19.7 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "19.7 27.7 19.7 29.6 29.6 29.6 29.6 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "29.6 27.7 29.6 29.6 39.6 29.6 39.6 27.7"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "MRNG",
    className: "st24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 9.8,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 14.8,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "39.6 13.6 29.7 2.8 29.7 4 19.8 4 19.8 23.2 29.7 23.2 29.7 24.4 39.6 13.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "9.8 27.7 9.8 29.6 19.7 29.6 19.7 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "19.7 27.7 19.7 29.6 29.6 29.6 29.6 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "29.6 27.7 29.6 29.6 39.6 29.6 39.6 27.7"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "21.3 8.5 24 1.7 26.7 8.5 35.8 3.3 30.5 12.3 37.3 15 30.5 17.7 35.8 26.8 26.7 21.5 24 28.3 21.3 21.5 12.2 26.8 17.5 17.7 10.7 15 17.5 12.3 12.2 3.3 21.3 8.5"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "POW",
    className: "st24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "21.9 8.6 24.7 1.5 27.6 8.6 37.1 3.1 31.6 12.6 38.7 15.4 31.6 18.3 37.1 27.8 27.6 22.3 24.7 29.4 21.9 22.3 12.4 27.8 17.9 18.3 10.8 15.4 17.9 12.6 12.4 3.1 21.9 8.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "23.4 12.2 24.7 8.9 26 12.2 30.5 9.7 27.9 14.1 31.3 15.5 27.9 16.8 30.5 21.2 26 18.7 24.7 22 23.4 18.7 18.9 21.2 21.5 16.8 18.1 15.5 21.5 14.1 18.9 9.7 23.4 12.2"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "MPOW",
    className: "st24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "21.9 8.6 24.7 1.5 27.6 8.6 37.1 3.1 31.6 12.6 38.7 15.4 31.6 18.3 37.1 27.8 27.6 22.3 24.7 29.4 21.9 22.3 12.4 27.8 17.9 18.3 10.8 15.4 17.9 12.6 12.4 3.1 21.9 8.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "23.4 12.2 24.7 8.9 26 12.2 30.5 9.7 27.9 14.1 31.3 15.5 27.9 16.8 30.5 21.2 26 18.7 24.7 22 23.4 18.7 18.9 21.2 21.5 16.8 18.1 15.5 21.5 14.1 18.9 9.7 23.4 12.2"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "DMG",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M21.2,19l4,4s6.9-7,8.9-10.4c1.4-2.3,4.4-10.8,4.4-10.8,0,0-8.6,3-10.8,4.4-3.4,2.1-10.4,8.9-10.4,8.9l4,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "22.3 20.1 31.7 8.5 20 17.8 22.3 20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M16,24.2l2.7,2.7,3.2-3.2s1.1,1.6,1.7,1.6c.7,0,2-2,2-2l-4.4-4.4-4.4-4.4s-2,1.3-2,2c0,.6,1.6,1.7,1.6,1.7l-3.2,3.2,2.7,2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M18.7,26.9s-1.5,2.2-2.2,2.2c-1.9.2-5.5-3.5-5.5-5.5,0-.8,2.2-2.2,2.2-2.2l5.5,5.5Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "MDMG",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M21.2,19l4,4s6.9-7,8.9-10.4c1.4-2.3,4.4-10.8,4.4-10.8,0,0-8.6,3-10.8,4.4-3.4,2.1-10.4,8.9-10.4,8.9l4,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "22.3 20.1 31.7 8.5 20 17.8 22.3 20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M16,24.2l2.7,2.7,3.2-3.2s1.1,1.6,1.7,1.6c.7,0,2-2,2-2l-4.4-4.4-4.4-4.4s-2,1.3-2,2c0,.6,1.6,1.7,1.6,1.7l-3.2,3.2,2.7,2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M18.7,26.9s-1.5,2.2-2.2,2.2c-1.9,0-5.5-3.5-5.5-5.5,0-.8,2.2-2.2,2.2-2.2l5.5,5.5Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "AWA",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M38.6,17.7s-13.9,20.7-27.8,0h0c13.9-20.7,27.8,0,27.8,0h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 24.7,
    cy: 17.7,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 24.7,
    cy: 17.7,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M10.9,11.9s.3-.4.8-1.2c.2-.4.6-.8,1-1.3.2-.2.4-.5.6-.8.2-.3.6-.5.8-.7.3-.3.6-.5,1-.8.3-.3.7-.5,1.1-.8.8-.5,1.6-1,2.5-1.4.9-.4,1.9-.7,2.9-.9,1-.2,2.1-.3,3.1-.3,1.1,0,2.1.2,3.1.5,1,.3,2,.6,2.9,1,1.8.8,3.3,1.8,4.6,2.8.3.3.6.4.9.7.2.3.5.5.7.8.4.5.8.9,1,1.3.5.7.8,1.2.8,1.2,0,0-.4-.3-1.1-.9-.4-.3-.8-.6-1.3-1-.2-.2-.5-.4-.8-.6-.3-.2-.5-.5-.8-.7-1.2-.9-2.7-1.9-4.4-2.7-.8-.4-1.8-.7-2.7-1-.9-.2-1.9-.4-2.9-.4-1,0-2,0-2.9.3-1,.2-1.9.5-2.7.9-.8.4-1.6.8-2.3,1.3-.4.2-.7.5-1,.7-.3.2-.6.5-.9.7-.5.5-1.1.9-1.6,1.3-.5.4-.9.7-1.2,1-.7.6-1.1.9-1.1.9Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "WGT",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M35.1,11.4l-.9-1h-3.9c3.6,0,3.3-1.6,3.3-5,0-2.7-4.2-4.8-8.9-4.8s-8.9,2.1-8.9,4.8c0,3.4-.3,5,3.3,5h-3.9l-.9,1-4.4,14.3,1.6,4.7h26.4l1.6-4.7-4.4-14.3ZM24.6,7.9c-6,0-6.2.5-6.2-2.3s4-2.7,6.2-2.7,6.2,1.2,6.2,2.7c0,2.8-.2,2.3-6.2,2.3Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "REG",
    className: "st24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16.1 17.7 16.1 11.4 22.4 11.4 22.4 17.7 28.7 17.7 28.7 24.1 22.4 24.1 22.4 30.4 16.1 30.4 16.1 24.1 9.8 24.1 9.8 17.7 16.1 17.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32 10.9 32 7.1 35.8 7.1 35.8 10.9 39.7 10.9 39.7 14.7 35.8 14.7 35.8 18.5 32 18.5 32 14.7 28.2 14.7 28.2 10.9 32 10.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "24.7 3 24.7 .5 27.2 .5 27.2 3 29.7 3 29.7 5.5 27.2 5.5 27.2 8 24.7 8 24.7 5.5 22.2 5.5 22.2 3 24.7 3"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SUR",
    className: "st24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 13.7,
    y: 25.4,
    width: 22.1,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 13.7,
    y: 20.5,
    width: 22.1,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "24.7 1 10.7 12.5 13.7 12.5 13.7 20.5 35.7 20.5 35.7 12.5 38.6 12.5 24.7 1"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "WIL",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M14.4,20.1s-.9-1.2-1.2-2.1c-.4-1.2-.4-4,0-5.3.4-1.4,2.1-4,3.3-4.9,1-.7,3.5-1.3,4.7-1.3,1.2,0,3.7.6,4.7,1.2,1.6.9,2.1,5.3,2.1,5.3l-.8,1.7.9,1.5,1.3,1.6-.4.9-1,.9v.4s.4.4.4.4l-.3.4v.5c0,0-.3.6-.3.6l-.4.5.3,1.2-.3.8-1.3.4-2.5.6-2.9-1.5s-.7,2.2-.7,3c0,.4.4,1.6.4,1.6,0,0-.8,1.2-1.2,1.4-.8.4-2.6.4-3.4.1-1.1-.4-2.8-2.4-3.4-3.4-.4-.6-.8-2.8-.8-2.8l2.3-2.4.4-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M26.6,4.5s.2,0,.5,0c.2,0,.4,0,.6.2.1,0,.2,0,.4.2.1,0,.2.2.3.3.8.8,1.5,2.1,2,3.4.5,1.3.7,2.8.7,3.9,0,.1,0,.3,0,.4,0,.1-.1.2-.2.3-.1.2-.2.4-.3.5-.2.3-.3.4-.3.4,0,0,0-.2,0-.5,0-.1,0-.3,0-.5,0-.2,0-.4,0-.7,0-1-.1-2.3-.6-3.5-.5-1.2-1.2-2.4-1.8-3.1,0,0-.2-.1-.2-.2,0-.1-.1-.2-.2-.3-.1-.2-.2-.3-.3-.4-.2-.2-.3-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M29,2.5s.2,0,.6,0c.2,0,.4.1.7.2.1,0,.3.1.4.2.1,0,.2.2.4.3.4.5.9,1.1,1.4,1.8.4.7.8,1.5,1.1,2.3.1.4.3.8.4,1.2.1.4.2.8.3,1.2.1.8.2,1.6.1,2.2,0,.2,0,.3,0,.5,0,.1-.1.3-.2.4-.1.3-.2.5-.3.6-.2.3-.4.5-.4.5,0,0,0-.2,0-.6,0-.2,0-.4,0-.7,0-.2,0-.5,0-.8,0-.6,0-1.3-.1-2,0-.4-.1-.8-.3-1.1,0-.4-.2-.8-.4-1.1-.3-.8-.6-1.5-1-2.1-.4-.7-.8-1.2-1.2-1.6,0-.1-.2-.2-.3-.3,0-.1-.1-.2-.2-.3-.1-.2-.3-.4-.4-.5-.3-.3-.4-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M31.8.7s.2,0,.7.1c.2,0,.5.2.8.3.2,0,.3.1.4.2.1,0,.2.2.4.4.2.3.5.6.8.9.2.3.5.7.7,1.1.5.8.9,1.7,1.2,2.6.2.5.3.9.4,1.4.1.5.2.9.3,1.4.1.9.2,1.8.1,2.5,0,.2,0,.4,0,.5,0,.2-.1.3-.2.5-.1.3-.2.5-.4.7-.2.4-.4.6-.4.6,0,0,0-.2,0-.7,0-.2,0-.5,0-.7,0-.3,0-.6,0-.9,0-.7,0-1.4-.1-2.3,0-.4-.2-.8-.3-1.3-.1-.4-.3-.9-.4-1.3-.3-.8-.7-1.7-1.2-2.4-.2-.4-.5-.7-.7-1-.2-.3-.5-.6-.7-.8-.1-.1-.3-.2-.3-.3,0-.1-.2-.3-.2-.4-.2-.2-.3-.4-.5-.6-.3-.3-.5-.5-.5-.5Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "STL",
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M17.2,17.4s-1.1-1.4-1.5-2.5c-.5-1.5-.5-4.8,0-6.3.5-1.7,2.5-4.8,3.9-5.8,1.2-.8,4.1-1.5,5.6-1.5,1.4,0,4.4.7,5.6,1.4,1.9,1.1,2.5,6.3,2.5,6.3l-1,2,1.1,1.8,1.5,1.9-.4,1.1-1.2,1v.5s.4.5.4.5l-.4.5v.6c0,0-.3.8-.3.8l-.4.6.3,1.5-.3.9-1.5.5-2.9.8-3.4-1.8s-.8,2.6-.8,3.5c0,.5.5,1.9.5,1.9,0,0-1,1.5-1.5,1.7-.9.4-3.1.5-4,.2-1.3-.5-3.3-2.8-4-4-.4-.7-1-3.3-1-3.3l2.7-2.8.4-1.8Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M31.1,1.1c4,.5,4.9,4,1.7,6.5l-.4.2v1.1c.1,0,1.9.8,1.9.8,1.7.8,2.1,3.1,2.7,4.7l.8,4-2.4.4-.2,4.4-2.2,7.1h-4c-.6-2.1-1.5-5-2.2-7.1l-.2-4.4-2.4-.4.8-4c.6-1.6,1-3.9,2.7-4.7l1.8-.8v-1.1c.1,0-.2-.2-.2-.2-3.2-2.5-2.3-6,1.7-6.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "9.6 7.2 25.9 4.6 25.9 6.8 9.6 7.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "8.1 11.3 22.9 10 22.9 12.2 8.1 11.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "7.9 16 23 14.8 23 17 7.9 16"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "7.6 20.1 23.6 20.2 23.6 22.4 7.6 20.1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "13.3 25.6 25.4 25 25.4 27 13.3 25.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M0,3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodge);
export default __webpack_public_path__ + "static/media/dodge.7b46fb2f0f84527c149091ed644ca2a6.svg";
export { ForwardRef as ReactComponent };